import { Box, Grid, GridSpacing, makeStyles } from '@material-ui/core';
import { DSScreen, DSScreenCell, DSScreenMenuCell, Order } from 'kiolyn-api';
import React, { FC } from 'react';
import Banner from './Banner';
import MenuCell from './MenuCell';
import ImageCell from './ImageCell';
import SlideshowCell from './SlideshowCell';
import StatusBoardCell from './StatusBoardCell';

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    margin: 0
  },
  menuContainer: {
    padding: theme.spacing(2),
    margin: 0,
    height: '100%'
  },
  columnContainer: {
    height: '100%'
  }
}));

interface ScreenProps {
  screen: DSScreen;
  orders?: Order[];
}

const Screen: FC<ScreenProps> = ({ screen, orders }: ScreenProps) => {
  const classes = useStyles();
  const columns = screen.columns || [];

  let spacing: GridSpacing = 0;
  let xs: 12 | 6 | 4 = 12;
  if (columns.length === 2) {
    spacing = 4;
    xs = 6;
  } else if (columns.length === 3) {
    spacing = 2;
    xs = 4;
  }

  const renderCell = (index: number, screen: DSScreen, cell: DSScreenCell) => {
    if (cell.type === 'category' && (cell as DSScreenMenuCell).list_thumbnail) {
      return <ImageCell key={index} screen={screen} cell={cell} />;
    } else if (cell.type === 'category') {
      return <MenuCell key={index} screen={screen} cell={cell} />;
    } else if (cell.type === 'slideshow') {
      return <SlideshowCell key={index} cell={cell} />;
    } else if (cell.type === 'statusboard') {
      return <StatusBoardCell key={index} cell={cell} orders={orders} />;
    }
    return null;
  };

  return (
    <Box
      className={classes.container}
      style={{
        backgroundColor: screen.background
      }}
    >
      <Banner
        imageUrl={screen.top_image_url}
        height={screen.top_image_height}
      />
      <Grid
        key="content"
        container
        direction="row"
        justify="space-between"
        alignItems="flex-start"
        spacing={spacing}
        className={classes.menuContainer}
      >
        {columns.map((column, index) => (
          <Grid
            container
            key={index}
            item
            xs={xs}
            direction="column"
            className={classes.columnContainer}
          >
            {(column.cells || []).map((cell, index) =>
              renderCell(index, screen, cell)
            )}
          </Grid>
        ))}
      </Grid>
      <Banner
        imageUrl={screen.bottom_image_url}
        height={screen.bottom_image_height}
        position="bottom"
      />
    </Box>
  );
};

export default Screen;
